<template>
  <div id="settingsNotificationsSchedule">

    <div class="name">Notification Schedule</div>

    <div>

      <div class="context">Select when you would like to receive notifications. You can choose to always receive notifications, or use your own customizable notification schedule.</div>

      <div class="type">
        <span class="type-name">Push Notifications</span>
        <v-btn-toggle mandatory class="bar float-right" v-model="togglePush">
          <v-btn class="option" flat value="on">
            USE SCHEDULE
          </v-btn>
          <v-btn class="option" flat value="off">
            ALWAYS ON
          </v-btn>
        </v-btn-toggle>
        <div class="clear"></div>
      </div>   

      <div class="type">
        <span class="type-name">Email Notifications</span>
        <v-btn-toggle mandatory class="bar float-right" v-model="toggleEmail">
          <v-btn class="option" flat value="on">
            USE SCHEDULE
          </v-btn>
          <v-btn class="option" flat value="off">
            ALWAYS ON
          </v-btn>
        </v-btn-toggle>   
        <div class="clear"></div>
      </div>   

      <div class="line"></div>

      <div class="notification-schedule" :class="{active: toggleEmail === 'on' || togglePush === 'on'}">
      <div class="name smaller">Custom Schedule</div>

      <div class="context">Select when you'd like to receive scheduled notifications. You will only receive notifications for events that occur within your schedule.</div>

        <div class="day" v-for="(day, key) in week" :key="key" :class="{schedule: day.type === 'schedule'}">

          <div class="day-name">{{ day.name }}</div>

          <v-btn-toggle mandatory class="bar" v-model="day.type">
            <v-btn class="option" flat value="off">
              NONE
            </v-btn>
            <v-btn class="option" flat value="schedule">
              SCHEDULE
            </v-btn>
            <v-btn class="option" flat value="on">
              ALL DAY
            </v-btn>
          </v-btn-toggle>


          <div class="inputs">
            <div class="time" v-if="day.slider">
              <span>{{ formatSliderTime(day.slider.get()[0]) }}</span> to <span>{{ formatSliderTime(day.slider.get()[1]) }}</span>
            </div>

            <div class="slider" :ref="key + 'Slider'"></div>          
          </div>

          <div class="clear"></div>

        </div>
      </div>

    </div>
    <div class="buttons">
      <!-- <v-btn flat color="primary" :disabled="lockout" @click="initSchedule">Undo</v-btn> -->
      <v-btn flat color="primary" :loading="lockout" @click="save">Save</v-btn>
    </div>
    <div class="clear"></div>
    
  </div>

</template>


<script>

import nouislider from 'nouislider'

  export default {
    data () {
      return {
        lockout: false,
        
        schedule: {},

        toggleEmail: false,
        togglePush: false,

        week: {
          monday: {
            name: 'MON',
            start: null,
            end: null,
            type: 'on'
          },
          tuesday: {
            name: 'TUE',
            start: null,
            end: null,
            type: 'on'
          },
          wednesday: {
            name: 'WED',
            start: null,
            end: null,
            type: 'on'
          },
          thursday: {
            name: 'THU',
            start: null,
            end: null,
            type: 'on'
          },
          friday: {
            name: 'FRI',
            start: null,
            end: null,
            type: 'on'
          },
          saturday: {
            name: 'SAT',
            start: null,
            end: null,
            type: 'on'
          },
          sunday: {
            name: 'SUN',
            start: null,
            end: null,
            type: 'on'
          }
        }
      }
    },
    computed: {
      
      sliderOptions () {

        var ranges = {};
        var tick = [];
        for (var i = 0; i <= 24; ++i) {
          
          tick = [i];
          
          if (0 < i && i < 24) ranges[((100/24) * i) + '%'] = tick;
          else if (i === 0) ranges['min'] = tick;
          else if (i === 24) ranges['max'] = tick;
        }

        return {
          start: [ 0, 24 ],
          connect: true,
          mode: 'steps',
          step: 1,
          margin: 1,
          tooltips: false,
          pips: {
            mode: 'steps',
            filter: this.sliderPipFilter,
            density: 3,
            format: {
              to: function ( value ) {
                return this.sliderFormatTime(value);
              }.bind(this),
              from: function ( value ) {
                return value.replace(this.sliderFormatTime(value), '');
              }.bind(this)
            },
          },

          range: {
            'min': 0,
            'max': 24 
          }
        };
      }
    },
    methods: {
      
      save () {
        if (this.lockout) return;
        this.lockout = true;

        var week = {};
        for (var key in this.week) {

          var day;

          // All Day
          if (this.week[key].type === 'on') {
            day = {
              on: true,
              start: 0,
              end: 1440
            };
          }
          else {
            day = {
              on: this.week[key].type === 'schedule',
              start: this.week[key].slider.get()[0] * 60,
              end: this.week[key].slider.get()[1] * 60
            };
          }
         
          week[key] = day;
        };

        var notificationSettings = {
          schedulePush: this.togglePush === 'on',
          scheduleEmail: this.toggleEmail === 'on',
          schedule: week
        };
  
        this.$store.dispatch('saveNotificationSchedule', {
          notificationSettings: notificationSettings
        })
        .then(function (data) {
          Toast.show('Changes saved.', 'success');
          this.lockout = false;
        })
        .catch(function (e) {
          console.log('Error -', e);
          this.lockut = false;
          Toast.showError(e);
        });
      },
      
      clearDay (day) {
        day.start = null;
        day.end = null;
      },
      
      sliderFormatTime (i) {
        i = parseInt(i);
        var str = 'AM';
        if (i > 11 && i < 24) str = 'PM';
        var num = ((i + 12) % 12);
        if (num === 0) num = 12;
        return (num + str);
      },

      formatSliderTime (i) {
        return this.sliderFormatTime(i);
      },

      sliderPipFilter (value, type) {
        return value % 3 === 0 ? 2 : 0;
      },

      initSchedule () {

        this.schedule = {...this.$store.getters.profile.notificationSettings.schedule};

        this.toggleEmail = this.$store.getters.profile.notificationSettings.scheduleEmail ? 'on' : 'off';
        this.togglePush = this.$store.getters.profile.notificationSettings.schedulePush ? 'on' : 'off';

        this.$nextTick(() => {
          
          for (var key in this.week) {
            this.week[key].type = this.schedule[key].on 
            ? ((this.schedule[key].start === 0 && this.schedule[key].end === 1440) ? 'on' : 'schedule')
            :'off'
            

            if (!this.week[key].slider) {
              this.sliderOptions.start = [this.schedule[key].start / 60, this.schedule[key].end / 60];
              this.week[key].slider = nouislider.create(this.$refs[key + 'Slider'][0], this.sliderOptions);
              this.week[key].slider.on('update', function () { this.$forceUpdate(); }.bind(this));
            }
            else {
              this.week[key].slider.set([this.schedule[key].start / 60, this.schedule[key].end / 60]);
            }

          }

          this.$nextTick(() => {
            this.$forceUpdate();
          });

        })
      }

    },

    created () {
      this.initSchedule();
    },

    beforeDestroy () {
      for (var key in this.week) {
        if (this.week[key].slider) {
          this.week[key].slider.destroy();
        }
      }
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #settingsNotificationsSchedule {
    position: relative;  
  

    .notification-schedule {
      opacity: .24;
      pointer-events: none;
      transition: all .3s ease;

      &.active {
        opacity: 1;
        pointer-events: auto;
      }
    }

    .type {
      width: 340px;
      margin: 20px auto;

      .float-right {
        float: right;
      }

      .type-name {
        line-height: 36px;
        height: 36px;
        width: 100px;
      }
    }

    .line {
      border-bottom: $borderBlack12;
      width: 100%;
      padding: 16px 0;
    }

    .name.smaller {
      font-size: 14px;
      color: $black54;
      border-bottom: none;
      padding: 16px 0 0;
    }

    .day {
      position: relative;
      height: 80px;
      box-sizing: border-box;
      padding: 0 16px;
      overflow: hidden;
      transition: all .3s ease;

      &:nth-child(even) {
        background: $black06
      }

      .bar {
        margin: 14px;
        width: calc(100% - 70px);

        .option {
          width: 33.3333333333333333%;
        }
      }

      .day-name {
        @include fontPrimary500;
        @include title();
        font-size: 12px;
        color: $black54;
        text-align: center;
  
        width: 40px;
        float: left;
        line-height: 67px;
      }

      .inputs {
        position: absolute;
        left: 60px;
        width: calc(100% - 110px);
        pointer-events: none;
        opacity: 0;
        transition: all .3s ease;

        .start {
          float: left;
          margin: 0 0 0 16px;
          width: calc(50% - 16px);
        }

        .end {
          float: left;
          margin: 0 0 0 16px;
          width: calc(50% - 16px);
        }

      }

      .time {
        @include fontPrimary500();
        @include title();

        height: 30px;
        margin-top: 8px;
        text-align: center;
        font-size: 12px;
        color: $black54;

        span {
          padding: 0 8px;
          font-size: 14px;
          color: $primary;
        }
      }

      .slider {
        height: 20px;
      }

      &.schedule {
        height: 180px;

        .inputs {
          opacity: 1;
          pointer-events: auto;
        }
      }

    }

    @media screen and (max-width: 600px) {

      .day {

        .inputs {

          width: calc(100% - 120px);

          .start, .end {
            float: none;
            width: 100%;
          }

        }
      
      &.schedule {
          height: 180px;

          .inputs {
            opacity: 1;
            pointer-events: auto;
          }
        }

      }
    }

    @media screen and (max-width: 420px) {
        
      .type {
        width: calc(100% - 32px);
        margin: 20px auto;
      

        .float-right {
          float: none;
          width: 100%;
          margin: 0 auto;
          .btn {
            width: 50%;
          }
        }

        .type-name {
          line-height: 36px;
          height: 36px;
          width: 100px;
        }
      }


      .day {

        padding: 0 0 0 8px;        

        .btn {
          font-size: 12px !important;
        }
      
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/SettingsNotificationsSchedule.vue